import React from "react";
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const AuthSuccess = React.lazy(() => import('../pages/auth/AuthSuccess'));

const SponsorList = React.lazy(() => import('../pages/apps/Sponsor/List'));
const PublishedList = React.lazy(() => import('../pages/apps/Sponsor/PublishedList'));
const SponsorAdd = React.lazy(() => import('../pages/apps/Sponsor/Add'));
const ViewSponsor = React.lazy(() => import('../pages/apps/Sponsor/PreviewPage'));
const AppointmentsList = React.lazy(() =>import('../pages/apps/Sponsor/AppointmentsList'));
const SponsorApprovalList= React.lazy(() => import('../pages/apps/Sponsor/ApprovalList'));
const SponsorApprovalAdd= React.lazy(() => import('../pages/apps/Sponsor/ApprovalAdd'));
const SponsorApprovalAction= React.lazy(() => import('../pages/apps/Sponsor/ApprovalAction'));
const MonthlyReportScreen = React.lazy(() => import('../pages/apps/Report/MonthlyReportScreen'));
const MonthlyReportAppVsWeb = React.lazy(() => import('../pages/apps/Report/MonthlyReportAppVsWeb'));
const ReportApprovalAction= React.lazy(() => import('../pages/apps/Report/ApprovalAction'));
const AppWebSingle = React.lazy(() => import('../pages/apps/Report/AppWebSingle'));
const RunningAppvsWeb = React.lazy(() => import('../pages/apps/Report/RunningAppvsWeb'));
const RunningAppvsWebMember = React.lazy(() => import('../pages/apps/Report/RunningAppvsWebMember'));

const CMSReport = React.lazy(() => import('../pages/apps/Report/CMSReport'));
const PullLogList = React.lazy(() => import('../pages/apps/Report/PullLogList'));

const SponsorPermissionsScreen = React.lazy(() => import('../pages/apps/Admin/SponsorPermissions'));
const UsersScreen = React.lazy(() => import('../pages/apps/Admin/Users'));
const MenuScreen = React.lazy(() => import('../pages/apps/Admin/Menus'));
const RolesScreen = React.lazy(() => import('../pages/apps/Admin/Roles'));

const OTPScreen = React.lazy(() => import('../pages/apps/DevTools/OTPScreen'));
const CryptoTools = React.lazy(() => import('../pages/apps/DevTools/CryptoTools'));
const UpdateMongo = React.lazy(() => import('../pages/apps/DevTools/UpdateMongo'));
const MemberTools = React.lazy(() => import('../pages/apps/DevTools/MemberTools'));
const MemberSettings = React.lazy(() => import('../pages/apps/DevTools/MemberSettings'));

const Home = React.lazy(() => import('../pages/apps/Home/index'));
// maternity
const AddMaternityUserForm = React.lazy(() => import('../pages/apps/Maternity/addMaternityUser'));
const AddMaternityUserExcelUpload = React.lazy(() => import('../pages/apps/Maternity/addMaternityUserExcelUpload'));
const AddMaternityUserExcel = React.lazy(() => import('../pages/apps/Maternity/addMaternityUserExcel'));
const ListMaternityUser = React.lazy(() => import('../pages/apps/Maternity/listMaternityUser'));
const addMaternityCase = React.lazy(() => import('../pages/apps/Maternity/addMaternityCase'));
const ListMaternityCase = React.lazy(() => import('../pages/apps/Maternity/listMaternityCase'));
const ListMaternityEvent = React.lazy(() => import('../pages/apps/Maternity/listMaternityEvents'));
const ListMaternityFeedback = React.lazy(() => import('../pages/apps/Maternity/listMaternityFeedback'));
const ListMaternityLogsStaging = React.lazy(() => import('../pages/apps/Maternity/listMaternityStaging'));
const ListMaternityLogsIncomming = React.lazy(() => import('../pages/apps/Maternity/listMaternityTellephantLogsIncoming'));
const ListMaternityLogsOutgoing = React.lazy(() => import('../pages/apps/Maternity/listMaternityTellephantLogsOutgoing'));
const MaternityDashboard = React.lazy(() => import('../pages/apps/Maternity/dashboardPage'));
// const MaternityDashboard1 = React.lazy(() => import('../pages/apps/Maternity/dashboardPageFull'));
const MaternityDashboard1 = React.lazy(() => import('../pages/apps/Maternity/Dashboard/Dashboard'));
const SendMaternityTips = React.lazy(() => import('../pages/apps/Maternity/sendMaternityTips'));
const ListMaternityTimeline = React.lazy(() => import('../pages/apps/Maternity/timelineMaternityUser'));
const ListMaternityRegistrations = React.lazy(() => import('../pages/apps/Maternity/listMaternityRegistrations'));
const ListMaternityLogsStagingSuhas = React.lazy(() => import('../pages/apps/Maternity/listMaternityStagingSuhas'));
const Userprofile = React.lazy(() => import('../pages/apps/Maternity/Profile/index'));
const ListMaternityTransfer = React.lazy(() => import('../pages/apps/Maternity/listMaternityTransfer'));
const ListCheckin = React.lazy(() => import('../pages/apps/Maternity/listCheckin'));
const AddCheckin = React.lazy(() => import('../pages/apps/Maternity/addCheckin'));
const CheckinDetail = React.lazy(() => import('../pages/apps/Maternity/checkinDetail'));
const SponsorEntitlement = React.lazy(() => import('../pages/apps/Maternity/sponsorEntitlement'));

const ListCheckinWhatsapp = React.lazy(() => import('../pages/apps/Maternity/listCheckinWhatsapp'));

const CorporateList= React.lazy(() => import('../pages/apps/Corporate/CorporateList'));
const CorporateApprovalList= React.lazy(() => import('../pages/apps/Corporate/CorporateApprovalList'));
const CorporateApprovalAction= React.lazy(() => import('../pages/apps/Corporate/CorporateApprovalAction'));
const CorporateAdd= React.lazy(() => import('../pages/apps/Corporate/CorporateAdd'));
const AgreementList= React.lazy(() => import('../pages/apps/Agreement/AgreementList'));
const AgreementAdd= React.lazy(() => import('../pages/apps/Agreement/AgreementAdd'));
const AgreementDocument= React.lazy(() => import('../pages/apps/Agreement/AgreementDocument'));

const ContactList= React.lazy(() => import('../pages/apps/Contacts/ContactList'));
const ContactAdd= React.lazy(() => import('../pages/apps/Contacts/ContactAdd'));

const BillingList= React.lazy(() => import('../pages/apps/Billing/BillingList'));
const BillingAdd= React.lazy(() => import('../pages/apps/Billing/BillingAdd'));

const DynamicFormList= React.lazy(() => import('../pages/apps/DynamicForm/DynamicFormList'));
const DynamicFormAdd= React.lazy(() => import('../pages/apps/DynamicForm/DynamicFormAdd'));

const DynamicFormFieldList= React.lazy(() => import('../pages/apps/DynamicFormField/DynamicFormFieldList'));
const DynamicFormFieldAdd= React.lazy(() => import('../pages/apps/DynamicFormField/DynamicFormFieldAdd'));

const DynamicFormRoleList= React.lazy(() => import('../pages/apps/DynamicFormRole/DynamicFormRoleList'));
const DynamicFormRoleAdd= React.lazy(() => import('../pages/apps/DynamicFormRole/DynamicFormRoleAdd'));

const RenderFormAdd= React.lazy(() => import('../pages/apps/DynamicForm/RenderFormAdd'));
const RenderFormList= React.lazy(() => import('../pages/apps/DynamicForm/RenderFormList'));

const CorporateProductList= React.lazy(() => import('../pages/apps/CorporateProducts/CorporateProductList'));
const CorporateProductAdd= React.lazy(() => import('../pages/apps/CorporateProducts/CorporateProductAdd'));

const Calender= React.lazy(() => import('../pages/apps/Intake/CounsellorsSlot1'));
const CalenderNew= React.lazy(() => import('../pages/apps/Intake/CounsellorSlot2'));


const MyProfile= React.lazy(() => import('../pages/apps/Setting/MyProfile'));
//intake
const IncomingCallView= React.lazy(() => import('../pages/apps/Intake/IncomingCallView'));
const IntakeScreen= React.lazy(() => import('../pages/apps/Intake/IntakeScreen'));


//Reporting Dashboard
const ReportingDashboard= React.lazy(() => import('../pages/dashboard/index'));
//Report management screen
const ReportManagementScreen= React.lazy(() => import('../pages/apps/Report/ReportDetailsScreen'));

const ReportSPOCManagementScreen= React.lazy(() => import('../pages/apps/Report/ReportSPOCManagementScreen'));

const AppointmentList= React.lazy(() => import('../pages/apps/Appointment/AppointmentList'));
const AppointmentDetails= React.lazy(() => import('../pages/apps/Appointment/AppointmentDetails'));
const SendNotification= React.lazy(() => import('../pages/apps/DevTools/sendNotification'));
const SurgeNotification= React.lazy(() => import('../pages/apps/DevTools/surgeNotification'));
const NotificationTemplate= React.lazy(() => import('../pages/apps/DevTools/notificationTemplate'));
const NotificationsTemplateList= React.lazy(() => import('../pages/apps/DevTools/NotificationsList'));
const NotificationsAnalytics= React.lazy(() => import('../pages/apps/DevTools/NotificationsAnalytics'));

const UpdateInteractions = React.lazy(() => import('../pages/apps/GuidedPrograms/UpdateInteractions'));
const RequestedSessions = React.lazy(() => import('../pages/apps/InternalReports/RequestedSessions'));
const MonthlyActiveUsers = React.lazy(() => import('../pages/apps/InternalReports/MonthlyActiveUsers'));
const MoodometerLogs = React.lazy(() => import('../pages/apps/InternalReports/MoodometerLogs'));
const TIGData = React.lazy(() => import('../pages/apps/InternalReports/TIGData'));
const TataReport = React.lazy(() => import('../pages/apps/InternalReports/TataReport'));
const CounsellingData = React.lazy(() => import('../pages/apps/InternalReports/CounsellingData'));
const GASReport = React.lazy(() => import('../pages/apps/InternalReports/GASReport'));
const GADPHQReport = React.lazy(() => import('../pages/apps/InternalReports/GADPHQReport'));
const PlatformUsage = React.lazy(() => import('../pages/apps/InternalReports/PlatformUsage'));
const AppointmentReport = React.lazy(() => import('../pages/apps/InternalReports/AppointmentReport'));
const TCSReport = React.lazy(() => import('../pages/apps/InternalReports/TCSReport'));
const GuidedProgramReport = React.lazy(() => import('../pages/apps/InternalReports/GuidedProgramReport'));
const SuicideRiskReport = React.lazy(() => import('../pages/apps/InternalReports/SuicideRiskReport'));

const Components = {
//Common
Home:Home,
Login:Login,
Logout:Logout,
UpdateMongo:UpdateMongo,
//SSO
AuthSuccess:AuthSuccess,
SponsorAdd: SponsorAdd,
ViewSponsor: ViewSponsor,
PublishedList:PublishedList,
AppointmentsList:AppointmentsList,
SponsorList: SponsorList,
SponsorApprovalList:SponsorApprovalList,
SponsorApprovalAdd:SponsorApprovalAdd,
SponsorApprovalAction:SponsorApprovalAction,

//report
AppWebSingle:AppWebSingle,
MonthlyReportScreen:MonthlyReportScreen,
MonthlyReportAppVsWeb:MonthlyReportAppVsWeb,
ReportApprovalAction:ReportApprovalAction,
RunningAppvsWeb:RunningAppvsWeb,
RunningAppvsWebMember:RunningAppvsWebMember,
CMSReport:CMSReport,
PullLogList:PullLogList,

//admin
SponsorPermissionsScreen:SponsorPermissionsScreen,
UsersScreen:UsersScreen,
MenuScreen:MenuScreen,
RolesScreen:RolesScreen,
//devtools
OTPScreen:OTPScreen,
CryptoTools:CryptoTools,
MemberTools:MemberTools,
MemberSettings:MemberSettings,

//Maternity
AddMaternityUserForm :AddMaternityUserForm,
AddMaternityUserExcelUpload :AddMaternityUserExcelUpload,
AddMaternityUserExcel: AddMaternityUserExcel,
ListMaternityUser :ListMaternityUser,
addMaternityCase :addMaternityCase,
ListMaternityCase :ListMaternityCase,
ListMaternityEvent:ListMaternityEvent,
ListMaternityFeedback :ListMaternityFeedback,
ListMaternityLogsStaging: ListMaternityLogsStaging,
ListMaternityLogsIncomming:ListMaternityLogsIncomming,
ListMaternityLogsOutgoing :ListMaternityLogsOutgoing,
MaternityDashboard :MaternityDashboard,
MaternityDashboard1 :MaternityDashboard1,
SendMaternityTips :SendMaternityTips,
ListMaternityTimeline :ListMaternityTimeline,
CorporateList:CorporateList,
CorporateApprovalList:CorporateApprovalList,
CorporateApprovalAction:CorporateApprovalAction,
CorporateAdd:CorporateAdd,
AgreementList:AgreementList,
AgreementAdd:AgreementAdd,
AgreementDocument:AgreementDocument,
ContactAdd:ContactAdd,
ContactList:ContactList,
BillingList:BillingList,
BillingAdd:BillingAdd,
DynamicFormList:DynamicFormList,
DynamicFormAdd:DynamicFormAdd,
DynamicFormFieldList:DynamicFormFieldList,
DynamicFormFieldAdd:DynamicFormFieldAdd,
DynamicFormRoleList:DynamicFormRoleList,
DynamicFormRoleAdd:DynamicFormRoleAdd,
RenderFormAdd:RenderFormAdd,
RenderFormList:RenderFormList,
CorporateProductList:CorporateProductList,
CorporateProductAdd:CorporateProductAdd,
ListMaternityRegistrations :ListMaternityRegistrations,
ListMaternityLogsStagingSuhas: ListMaternityLogsStagingSuhas,
Userprofile: Userprofile,
ListMaternityTransfer: ListMaternityTransfer,
ListCheckin:ListCheckin,
ListCheckinWhatsapp:ListCheckinWhatsapp,
AddCheckin:AddCheckin,
CheckinDetail:CheckinDetail,
SponsorEntitlement:SponsorEntitlement,

// Guided programs
UpdateInteractions:UpdateInteractions,

// Internal reports
RequestedSessions:RequestedSessions,
MonthlyActiveUsers:MonthlyActiveUsers,
MoodometerLogs:MoodometerLogs,
TIGData:TIGData,
TataReport:TataReport,
CounsellingData:CounsellingData,
GASReport:GASReport,
GADPHQReport:GADPHQReport,
PlatformUsage:PlatformUsage,
AppointmentReport: AppointmentReport,
TCSReport: TCSReport,
GuidedProgramReport: GuidedProgramReport,
SuicideRiskReport: SuicideRiskReport,

//Intake
IncomingCallView:IncomingCallView,
IntakeScreen:IntakeScreen,
Calender:Calender,
CalenderNew:CalenderNew,
MyProfile:MyProfile,

//Dashboard
ReportingDashboard:ReportingDashboard,

//Automated monthly report details management
ReportManagementScreen:ReportManagementScreen,

ReportSPOCManagementScreen:ReportSPOCManagementScreen,
AppointmentList:AppointmentList,
AppointmentDetails:AppointmentDetails,
SendNotification:SendNotification,
SurgeNotification:SurgeNotification,
NotificationTemplate:NotificationTemplate,
NotificationsTemplateList:NotificationsTemplateList,
NotificationsAnalytics:NotificationsAnalytics
};
 
export default block => {
    // component does exist    
    if (typeof block.component=="string" && typeof Components[block.component] !== "undefined") {      
      return Components[block.component];
    }else if(typeof block.component!="string"){
      return block.component
    }
    return Home
  }